// © Microsoft Corporation. All rights reserved.

import { CardContextMenuItem } from "@msnews/card-context-menu";
import { CoordinatePos } from "./SharingToolbar.props";
import { Glyph } from "@msnews/icon";
import { LikeDislikeActionKey } from "../../ContentActionsToolbar.constants";

/**
 * Default color for the icon container
 */
export const iconContainerDefaultColor = "#EEE";

/**
 * Colors for the more options icon
 */
export const moreOptionsIconColors = {
    background: iconContainerDefaultColor,
    foreground: "#666"
};

/**
 *  Background colors for the like dislike icon
 */
export const likeDislikeIconBackroundColor = {
    none: iconContainerDefaultColor,
    like: "#FF4343",
    dislike: "#666"
};

/**
 * Default offset position to display the more options context menu
 */
export const moreOptionsMenuDefaultOffsetPos: CoordinatePos = {
    x: 0,
    y: -80
};

/**
 * Menu items to render the like option
 */
export const OptionItemLike: CardContextMenuItem = {
    key: LikeDislikeActionKey.like,
    text: null,
    onSelect: null,
    icon: Glyph.Like,
    telemetryTag: null
};

/**
 * Menu items to render the dislike option
 */
export const OptionItemDislike: CardContextMenuItem = {
    key: LikeDislikeActionKey.dislike,
    text: null,
    onSelect: null,
    icon: Glyph.Disliked,
    telemetryTag: null
};

/**
 * Menu items to render the undo like option
 */
export const OptionItemUndoLike: CardContextMenuItem = {
    key: LikeDislikeActionKey.undoliked,
    text: null,
    onSelect: null,
    icon: Glyph.Like,
    telemetryTag: null
};

/**
 * Menu items to render the undo dislike option
 */
export const OptionItemUndoDislike: CardContextMenuItem = {
    key: LikeDislikeActionKey.undodisliked,
    text: null,
    onSelect: null,
    icon: Glyph.Dislike,
    telemetryTag: null
};